module.exports = __webpack_public_path__ + "img/slib_04.93f05821.png";